import * as Sentry from '@sentry/react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';
import { useData } from '../../../contexts/data-context/use-data';
import { deleteSwrFetcherWithDynamicUrl } from '../../../utils/delete-swr-fetcher-with-dynamic-url';

const BENEFICIARIES_API_PATH = '/api/beneficiaries';

export const useDeleteBeneficiary = () => {
  const { mutations } = useData();
  const { trigger, isMutating } = useSWRMutation<{ success: boolean }, Error, string, { urlSuffix: string }>(
    BENEFICIARIES_API_PATH,
    deleteSwrFetcherWithDynamicUrl,
  );

  const deleteBeneficiary = async (beneficiaryId: string): Promise<boolean> => {
    try {
      await trigger({ urlSuffix: `/${beneficiaryId}` });

      await mutations.handleDeleteUpdates({
        entityType: 'beneficiary',
        entityIds: [beneficiaryId],
      });

      toast.success('Recipient deleted');

      return true;
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          beneficiaryId,
          context: 'deleteBeneficiary',
        },
      });
      toast.error('Failed to delete recipient. Please try again.');
      throw error;
    }
  };

  return {
    deleteBeneficiary,
    isDeleting: isMutating,
  };
};
